import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { TranslateService } from '@ngx-translate/core';
import {  AngularFireDatabase } from 'angularfire2/database';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/timeout';
import 'rxjs/add/operator/toPromise';


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: string = 'list-page';

  pages: Array<{title: string, name: string}>;

  private defaultLang: northseafood.TAvailableLangs;

  constructor(
      public platform: Platform,
      private afAuth: AngularFireAuth,
      private translate: TranslateService,
      private db: AngularFireDatabase )
    {

    // used for an example of ngFor and navigation
    this.pages = [
      {
        title: this.translate.instant('reports'),
        name: 'list-page'
      },
      /* {
        title: this.translate.instant('gallery'),
        name: 'gallery'
      }, */
      {
        title: this.translate.instant('suppliers'),
        name: 'suppliers-list-page'
      },
      {
        title: this.translate.instant('version'),
        name: 'version-page'
      },
    ];

    this.defaultLang = <northseafood.TAvailableLangs>localStorage.getItem('lang');

    this.afAuth.authState
      .subscribe(user => {
        if ( !user ) {
          this.rootPage = 'login';
        }
    });


    translate.setDefaultLang(this.defaultLang);

    this.db.object('/applicationConfig/defaultLang')
      .take(1)
      .timeout(3000)
      .toPromise()
      .then( (lang: { $value:northseafood.TAvailableLangs, $exists: Function, $key: string }) => {
        this.setLang(lang.$value);
      })
      .catch(err => {
        console.error('[app:configuration] failed to set language from configuration, defaulting to english', err);
        this.setLang('en');
      });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.name);
  }

  /** Sets the language by updating local storage and telling the ngx translate service to change the lang */
  setLang(lang: northseafood.TAvailableLangs) {
    localStorage.setItem('lang', lang);

    this.translate.setDefaultLang(lang);
  }

  logout() {
    this.db.app.auth().signOut()
      .then(() => {
        return this.nav.setRoot('login')
      })
      .then(() => this.nav.goToRoot(null))
      .catch( err => console.error('[app:logout] failed to logout', err));
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts